import React, { useState } from 'react';
import { Divider } from 'antd';
import styles from './index.module.scss';
import { LoginType } from 'constant/auth';
import FridayTracker from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import IconWechatCirle from 'asset/image/icon_wechat_cirle.svg';
import IconLockCirle from 'asset/image/icon_lock_cirle.svg';
import IconPhoneCirle from 'asset/image/icon_phone_circle.svg';

const LginTypeButtons = [
  {
    icon: IconPhoneCirle,
    text: '验证码登录/注册',
    type: LoginType.MOBILE
  },
  {
    icon: IconWechatCirle,
    text: '微信登录',
    type: LoginType.QR_CODE
  },
  {
    icon: IconLockCirle,
    text: '密码登录',
    type: LoginType.PASSWORD
  }
];

interface IProps {
  type: LoginType;
  onChange?: (type: LoginType) => void;
}

const LoginTypeSwitch: React.FunctionComponent<IProps> = ({ type, onChange }) => {
  const [loginType, setLoginType] = useState(type || LoginType.MOBILE);

  const LginTypeButtonsShow = LginTypeButtons.filter((item) => item.type !== loginType);
  const handleTypeChange = function (type: LoginType) {
    setLoginType(type);
    onChange && onChange(type);
  };
  return (
    <div className={styles.main}>
      <div className={styles['other-login']}>
        <Divider>
          <span className={styles.divider}>其他登录方式</span>
        </Divider>
        <div className={styles['login-type']}>
          {LginTypeButtonsShow.map((item) => (
            <FridayTracker
              key={item.type}
              {...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_LOGIN_TOGGLE_TYPE}
              data={
                type === LoginType.MOBILE || type === LoginType.PASSWORD
                  ? type === LoginType.PASSWORD
                      ? { login_type_code: LoginType.PASSWORD, login_type_value: '密码登录' }
                      : { login_type_code: LoginType.MOBILE, login_type_value: '手机登录' }
                  : { login_type_code: LoginType.QR_CODE, login_type_value: '扫码登录' }

              }
            >
              <div className={styles['login-item']} onClick={() => handleTypeChange(item.type)}>
                <img src={item.icon}></img>
                <span>{item.text}</span>
              </div>
            </FridayTracker>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoginTypeSwitch;
